import {lang, LanguageSelector, ScSoftwareComponent} from "../../commons/language-selector";
import {sc$, labels} from "../../commons/commons";
import {JDlInfos, JProductInfos, JDownloadProductMetas, JDocProductMetas, JDocLocInfos, JDownloadProductSource, JWeblateTranslation} from "../../commons/api";
import * as productInfosProvider from "../../commons/product-infos";
import * as messages from "../../commons/messages";
import {JMessage} from "../../commons/messages";
import {JSX} from "wfr/commons/jsx"
import {SvcESSearch} from "wfr/search/essearch";
import {JHitSource} from "wfr/search/searchapi"
import {Dict} from "wfr/commons/common"

import {DownloadMessageBox} from "./product-message-box";
import {QuickAccess} from "../search/main";
import {sort, injectHtmlFrag} from "../commons";

export{init, DownloadProductComponent, IVersionSelector, msgList, productInfos, depsProducts, seeAlsoProducts, docProductInfos, families, familyMembers, urltree}


let urltree:string
let downloadEsUrl:string
let msgList:JMessage[]
let productInfos:JProductInfos<JDownloadProductMetas, JDlInfos>
let docProductInfos:JProductInfos<JDocProductMetas, any>
let seeAlsoProducts:Dict<JDownloadProductSource[]>  = {}
let depsProducts:Dict<JDownloadProductSource[]>  = {}
let families:Dict<JDownloadProductSource>  = {}
let familyMembers:Dict<JDownloadProductSource>  = {}

function s(key:string) {
	return labels[lang][key] as string;
}

async function init(downloadUT:string, downloadSearch:string) {
	urltree = downloadUT
	downloadEsUrl = downloadSearch
	productInfosProvider.init(downloadUT)
	messages.init(downloadEsUrl)

	const quickaccess = (document.querySelector("quick-access") as QuickAccess);
	quickaccess.init(urltree, downloadEsUrl).then()

	const ls = document.querySelector("language-selector") as LanguageSelector
	ls.addEventListener("language-change", buildPage)
	ls.addEventListener("language-change", (event)=>injectHtmlFrag(urltree))

	//Chargement des données principales
	loadData().then(()=>buildPage()).catch(()=>buildPage())
	injectHtmlFrag(urltree)
}

async function loadData() {
	await productInfosProvider.getProductInfos(document.querySelector("meta[itemprop='path']").getAttribute("content")).then(p=>{productInfos = p as JProductInfos<JDownloadProductMetas, JDlInfos>});
	const downloadSearch:SvcESSearch<JHitSource<JDownloadProductSource>> = new SvcESSearch(downloadEsUrl)

	/**
	 * Les see Also sont les produits qui dépendent de ce produit et de ses familles
	 */
	const seeAlsoRequest:any = {deps:[]}
	seeAlsoRequest.deps.push({"deps.product":`${productInfos.metas.productKey}@${productInfos.metas.majorVersion}`, "deps.firstMinorVersion":{"lte":productInfos.metas.minorVersion}})
	productInfos.metas.family?.forEach(family=>{
		seeAlsoRequest.deps.push({"deps.product":`${family.productKey}@${family.majorVersion}`, "deps.firstMinorVersion":{"lte":productInfos.metas.minorVersion}})
	})
	const depsRequest:any={path:productInfos.metas.deps.map(dep=>{return `*/${dep.product}*`})}
	const familyRequest:any = {family:{
		"family.productKey":productInfos.metas.productKey,
		"family.majorVersion":productInfos.metas.majorVersion,
		"family.minorVersion":productInfos.metas.minorVersion
	}}

	await Promise.all([
		//Load messages
		messages.getMessages(productInfos.metas).then(m => msgList = m),

		//Load doc product Infos
		productInfosProvider.getDocProductInfos(productInfos.metas).then(docPi => docProductInfos = docPi),

		//Load see also products
		downloadSearch.search("seeAlso", seeAlsoRequest).then(resp=>{
			resp.results.forEach(hit=>{
				const productRef = `${hit._source.productKey}@${hit._source.majorVersion}`
				if(!(productRef in seeAlsoProducts)) seeAlsoProducts[productRef] = []
				seeAlsoProducts[productRef].push(hit._source)
			})
			for(let key in seeAlsoProducts) {
				seeAlsoProducts[key].sort(sort)
			}
		}),

		//Load internal dep products
		depsRequest.path.length > 0 ? downloadSearch.search("deps", depsRequest).then(resp=>{
			resp.results.forEach(hit=>{
				const productRef = `${hit._source.productKey}@${hit._source.majorVersion}`
				const minor = parseFloat(hit._source.minorVersion)

				//On ajoute uniquement les versions mineures compatibles
				productInfos.metas.deps.forEach(dep=>{
					if(dep.product != productRef || minor < dep.firstMinorVersion) return
					if(!(productRef in depsProducts)) depsProducts[productRef] = [];
					depsProducts[productRef].push(hit._source)
				})
			})
		}):null,

		//Load families
		productInfos.metas.family?.length > 0 ? downloadSearch.search("families", {path:productInfos.metas.family.map(family=>family.path)}).then(resp=> {
				resp.results.forEach(hit=>{families[hit._source.path] = hit._source});}): null,

		//Load family membres (page famille uniquement)
		productInfos.metas.processing == "productFamily" ? downloadSearch.search("familyMembers", familyRequest).then(resp=>{
			//Conceptuellement, on peut avoir plusieurs mineurs d'une même famille affichée côte à côte.
			//La clé est donc complète avec le num de version mineur.
			resp.results.forEach(hit=> familyMembers[`${hit._source.productKey}@${hit._source.majorVersion}.${hit._source.minorVersion}`] = hit._source)
		}):null
	])
}

function buildPage() {
	document.querySelectorAll("version-selector, desc-box, products-box, seealso-box, family-box, quick-access").forEach(elmnt=>(elmnt as DownloadProductComponent).rebuild());

	//productHead
	const head = sc$("productHead")
	const h2 = head.querySelector("h2");
	h2.innerHTML = "";
	h2.append(<img class="logo" src={`${productInfos.metas.docProviderUrl}/logo`} alt={`${s("altLogo")} ${productInfos.metas.downloadLocInfos[lang].title}`}/>,
		<span class="productLabel">{productInfos.metas.downloadLocInfos[lang].title}</span>);
	const docLnk = head.querySelector("div.docLnk");
	docLnk.innerHTML = "";
	if(docProductInfos.metas.docLocInfos[lang].state == "valid")
		docLnk.append(<a class="doc" href={`${productInfos.metas.docProviderUrl}/${lang}`}><span>{s("doc")}</span></a>)

	//Head messages
	const headMessages = sc$("headMessages");
	headMessages.innerHTML = "";
	const versionWarning = (document.querySelector("version-selector") as unknown as IVersionSelector).getVersionWarnBox();
	if(versionWarning) headMessages.append(versionWarning)
	msgList.forEach(msg=>{ if(!msg.grpCodes && msg.level == "warning") headMessages.append(new DownloadMessageBox(msg));});
	msgList.forEach(msg=>{ if(!msg.grpCodes && msg.level == "info") headMessages.append(new DownloadMessageBox(msg));});
	msgList.forEach(msg=>{ if(!msg.grpCodes && msg.level.startsWith("intdep")) headMessages.append(new DownloadMessageBox(msg));});

	//Foot messages
	const footMessages = sc$("footMessages");
	footMessages.innerHTML = ""
	msgList.forEach(msg=>{ if(!msg.grpCodes && msg.level == "dep") footMessages.append(new DownloadMessageBox(msg));});
}

abstract class DownloadProductComponent extends ScSoftwareComponent{
	/**
	 * Mécanisme de load de data synchrone
	 */
	protected loaded:boolean = false

	loadData():void{
		this.loaded = true
	}
	rebuild():boolean{
		if(!this.loaded) this.loadData()
		return super.rebuild()
	}
}

interface IVersionSelector{
	getVersionWarnBox():DownloadMessageBox
}